// extracted by mini-css-extract-plugin
export default {"eventContent":"HistoryItem_eventContent__SsikT","title":"HistoryItem_title__FsPym","date":"HistoryItem_date__HyiV-"};